import React, { useState } from "react";
import { Modal } from 'react-bootstrap';


const ModalAsistencias = ({
  label = 'Ver Asistencias',
  data = []

}) => {
  
  const [modalShow, setModalShow] = useState(false);


  return (
    <React.Fragment>
      <p
        className="text-center"
        onClick={() => {
          setModalShow(true);
        }}
      >
        {label}
      </p>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h2 className=" mb-4">Asistencias</h2>
          <h3 className=" mb-4 text-mex">Descripción</h3>

          <ul>
            <li dangerouslySetInnerHTML={{
              __html: data,
            }}>
            </li>
          </ul>
          <div className="row">
            <div className='col-md-12 '>
            <div class="col-md-8 offset-md-3">
            <button class="container-buttons btn btn-primary btn-mis-datos text-uppercase ml-auto mb-5"
              type="submit"
              onClick={() => { setModalShow(false) }}>
               OK
            </button>
          </div>
            </div>
          </div>
        

        </Modal.Body>
      </Modal>
    </React.Fragment>
  );

}

export default ModalAsistencias